import { ChangeEvent } from 'react';
import { Select } from '@/components/Controls/Select';

interface ReminderLineSelectProps {
  label: string;
  placeholder: string;
  options: { label: string; value: string }[];
  value?: string;
  onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
}

export const ReminderLineSelect = ({
  label,
  placeholder,
  options,
  value,
  onChange,
}: ReminderLineSelectProps) => {
  return (
    <div>
      <div className="text-2sm text-slate-600 font-medium mb-1">
        {label}
        &nbsp;
        <span className="text-red-FF2929 text-[16px]">*</span>
      </div>
      <Select
        selectClassName="h-[36px] bg-gray-FCFCFC dark-mode:bg-coal-500 w-max"
        placeholder={placeholder}
        options={options}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
